<script lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { ButtonIconPosition } from '~/constants/button'
import type { ButtonEmphasis, ButtonShape } from '~/utils/button'
import { NuxtLink } from '#components'

export interface ButtonProps {
  variant?: ButtonIntent
  size?: ButtonSize
  color?: ButtonColor
  shape?: ButtonShape
  emphasis?: ButtonEmphasis
  icon?: IconDefinition
  iconPosition?: ButtonIconPosition
  href?: string
  to?: RouteLocationRaw
}
</script>

<script setup lang="ts">
withDefaults(
  defineProps<ButtonProps>(),
  {
    size: 'medium',
    color: 'blurple',
    shape: 'rounded',
    emphasis: 'standard',
    icon: undefined,
    iconPosition: 'left',
    href: undefined,
    to: undefined,
  },
)
</script>

<template>
  <component
    :is="$attrs.disabled ? 'button' : $attrs.type === 'label' ? 'label' : href ? 'a' : to ? NuxtLink : 'button'"
    type="button" :href="href" :to="to" :aria-disabled="$attrs.disabled" :class="[
      buttonVariants.base({
        intent: variant,
        color,
        shape,
        size,
        emphasis,
        disabled: typeof $attrs.disabled === 'boolean' ? $attrs.disabled : false,
      }),
      { 'p-2xs': !!icon && !$slots.default },
    ]"
  >
    <Icon v-if="icon && iconPosition === 'left'" :icon="icon" />
    <slot />
    <Icon v-if="icon && iconPosition === 'right'" :icon="icon" />
  </component>
</template>
